import { useEffect, useRef, useState } from 'react';

const useMouse = ref => {
  const frame = useRef(0);
  const [state, setState] = useState({
    docX: 0, // Mouse position in document
    docY: 0,
    posX: 0, // Mouse position in element
    posY: 0,
    elX: 0, // Element position
    elY: 0,
    elH: 0, // Element dimensions`
    elW: 0,
  });

  useEffect(() => {
    const moveHandler = (event) => {
      cancelAnimationFrame(frame.current);

      frame.current = requestAnimationFrame(() => {
        if (ref && ref.current) {
          const { left, top, width: elW, height: elH } = ref.current.getBoundingClientRect();
          const posX = left + window.scrollX;
          const posY = top + window.scrollY;
          const elX = event.pageX - posX;
          const elY = event.pageY - posY;

          setState({
            docX: event.pageX,
            docY: event.pageY,
            posX,
            posY,
            elX,
            elY,
            elH,
            elW,
          });
        }
      });
    };

    document.addEventListener('mousemove', moveHandler);

    return () => {
      cancelAnimationFrame(frame.current);
      document.removeEventListener('mousemove', moveHandler);
    };
  }, [ref]);

  return state;
};

export default useMouse;